import { useState } from "react";
import SignIn from "./SignIn";
import { Flex, Heading } from "@chakra-ui/react";
import VerifyOtpCode from "./VerifyOtpCode";
import { Navigate, Routes, Route } from "react-router-dom";
import SignUp from "./SignUp";
import { usePostOtpMutation } from "../../../api/auth.api";
import { useLocation, useNavigate } from "react-router";
import { ajaxErrorAlert, ajaxSuccessAlert } from "utils/alert";
import { roles } from "../../../common/enums/role";
import { getRole } from "../../../utils/jwtService";
import { PrivateRoute } from "../../../routes/PrivateRoute";

function AuthStepper() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [otpValue, setOtpValue] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [postOtp, response] = usePostOtpMutation();

  const authData = {
    phoneNumber: phoneNumber,
    otpCode: otpValue,
  };
  const clickHandler = () => {
    setStep(1);
    // setClicked(true);
  };
  const reviseClickHandler = () => {
    setStep(0);
    if (step === 0) {
      navigate("/auth/signin");
    }
  };

  const otpChangeHandler = (e: any) => {
    setOtpValue(e);
  };
  const verifyClickHandler = async () => {
    await postOtp(authData)
      .unwrap()
      .then((res) => {
        setSignUp(true);
        !isNewUser && ajaxSuccessAlert("خوش آمدید");
        localStorage.removeItem("landingFormValues");
        // navigate("/auth/register");

        isNewUser ? navigate("/auth/register") : navigate("/user");
      })
      .catch((error) => {
        //ajaxErrorAlert(error.data.error[0])
        ajaxErrorAlert("اطلاعات وارد شده اشتباه است");
        console.log("error", error.data.error[0]);
      });
  };

  return (
    <Flex className="auth" justifyContent="center">
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w="100%"
        maxW="1044px"
        mx="auto"
        justifyContent="center"
        mb="30px"
        pt={{ sm: "100px", md: "0px" }}
        direction="row-reverse"
      >
        <Heading></Heading>
        {/* {step === 0 ? (
          <>
            <SignIn
              setStep={setStep}
              setIsNewUser={setIsNewUser}
              setPhoneNumber={setPhoneNumber}
            />
          </>
        ) : (
          step === 1 && (
            <VerifyOtpCode
              value={otpValue}
              onChange={otpChangeHandler}
              reviseClick={reviseClickHandler}
              onClick={verifyClickHandler}
              status={response.status}
            />
          )
        )}

        {signUp && step === 2 && <SignUp />} */}

        <Routes>
          <Route
            path="/signin"
            element={
              <SignIn
                setStep={setStep}
                setIsNewUser={setIsNewUser}
                setPhoneNumber={setPhoneNumber}
              />
            }
          />

          <Route
            path="/verifyotp"
            element={
              <VerifyOtpCode
                value={otpValue}
                onChange={otpChangeHandler}
                reviseClick={reviseClickHandler}
                onClick={verifyClickHandler}
                status={response.status}
              />
            }
          />

          <Route
            path="/register"
            element={
              <PrivateRoute roles={roles.user}>
                <SignUp />
              </PrivateRoute>
            }
          />
        </Routes>
      </Flex>
    </Flex>
  );
}

export default AuthStepper;
